module.exports = __webpack_public_path__ + "static/media/card-view.7ae705c1.svg";